import { useState } from 'react';
import TuningSelector from '../../components/tuning-selector/TuningSelector'
import Guitar from '../../components/guitar(new)/Guitar'
import PossibleKeys from '../../components/possible-keys/PossibleKeys'
import { GUITAR_TUNINGS } from '../../data/tunings';
import { useMediaQuery } from '@mui/material';
import './scaleFinder.scss'
import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';

const ScaleFinder = () => {
    const [finderKey, setFinderKey] = useState([]);
    const [tuning, setTuning] = useState(GUITAR_TUNINGS[0].notes);
    const isMobile = useMediaQuery('(max-width: 768px)');
    return (
        <div className='scale-finder'>
            <h1>Scale Finder</h1>
            <div className='scale-finder__mobile-finder'>
                <FmdBadRoundedIcon />
                <div>Click note twice to select on mobile</div>
            </div>
            <div className='settings-container'>
                <div />
                <TuningSelector tuning={tuning} setTuning={setTuning} />
            </div>
            <Guitar vertical={isMobile} tuning={tuning} capo={null} activeNotes={finderKey} updateNotes={setFinderKey} clickToAddAndRemove={true} />
            <PossibleKeys selectedNotes={finderKey} setSelectedNotes={setFinderKey} />
        </div>
    )
}

export default ScaleFinder